import { render, staticRenderFns } from "./scene4Pc.vue?vue&type=template&id=79af890c&scoped=true&"
import script from "./scene4Pc.vue?vue&type=script&lang=js&"
export * from "./scene4Pc.vue?vue&type=script&lang=js&"
import style0 from "./scene4Pc.vue?vue&type=style&index=0&id=79af890c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af890c",
  null
  
)

export default component.exports